import {Button, Form, InputGroup, Table} from "react-bootstrap";
import {useState} from "@hookstate/core";
import {createAddress, getClientAddresses} from "../../../../Services/ApiService";

function AddressBlock(props) { // displays addresses of selected client
    const client = props.selectedClient;
    const addresses = useState(client.addresses);
    const jobValues = props.jobValues;

    const addressDivHidden = useState(true);

    const newAddress = useState({
        clientId: client.get().id,
        street: '',
        street2: '',
        city: '',
        state: '',
        zip: ''
    });

    function onBillingAddressChange(e) {
        if (e.target.value !== "-1") {
             const newBillAdd = addresses.get().filter(address => {
                return address.id.toString() === e.target.value;
            })[0];

            jobValues.billingAddressStreet.set(newBillAdd.street);
            jobValues.billingAddressStreet2.set(newBillAdd.street2);
            jobValues.billingAddressCity.set(newBillAdd.city);
            jobValues.billingAddressState.set(newBillAdd.state);
            jobValues.billingAddressZip.set(newBillAdd.zip);
        } else {
            jobValues.billingAddressStreet.set('');
            jobValues.billingAddressStreet2.set('');
            jobValues.billingAddressCity.set('');
            jobValues.billingAddressState.set('');
            jobValues.billingAddressZip.set('');
        }
    }

    function onShippingAddressChange(e) {
        if (e.target.value !== "-1") {
            const newShipAdd = addresses.get().filter(address => {
                return address.id.toString() === e.target.value;
            })[0];

            jobValues.shippingAddressStreet.set(newShipAdd.street);
            jobValues.shippingAddressStreet2.set(newShipAdd.street2);
            jobValues.shippingAddressCity.set(newShipAdd.city);
            jobValues.shippingAddressState.set(newShipAdd.state);
            jobValues.shippingAddressZip.set(newShipAdd.zip);

            jobValues.isPickup.set(false);
        } else {
            jobValues.shippingAddressStreet.set('');
            jobValues.shippingAddressStreet2.set('');
            jobValues.shippingAddressCity.set('');
            jobValues.shippingAddressState.set('');
            jobValues.shippingAddressZip.set('');

        }
    }

    function displayAddresses() {
        return <Table>
                <thead>
                    <tr>
                        <th>Billing</th>
                        <th>Shipping</th>
                        <th>Address</th>
                    </tr>
                </thead>
                <tbody>
                {addresses.get().map((address, idx) => {
                    return (
                        <tr key={idx}>
                            <td>
                                <Form.Check
                                    className={'addressSelectRadio col-1'}
                                    type={"radio"}
                                    name={'bAddressSelect'}
                                    value={address.id}
                                    onChange={onBillingAddressChange}
                                />
                            </td>
                            <td>
                                <Form.Check
                                    className={'addressSelectRadio col-1'}
                                    type={"radio"}
                                    name={'sAddressSelect'}
                                    value={address.id}
                                    onChange={onShippingAddressChange}
                                />
                            </td>
                            <td className={"col-10"}>
                                {address.street}<br/>
                                {address.street2 !== '' && <>{address.street2}<br/></>}
                                {address.city}, {address.state} {address.zip}
                            </td>
                        </tr>
                    )
                })}
                <tr>
                    <td>
                        <Form.Check
                            className={'addressSelectRadio col-1'}
                            type={"radio"}
                            name={'bAddressSelect'}
                            value={'-1'}
                            onChange={onBillingAddressChange}
                        />
                    </td>
                    <td>
                        <Form.Check
                            className={'addressSelectRadio col-1'}
                            type={"radio"}
                            name={'sAddressSelect'}
                            value={-1}
                            onChange={onShippingAddressChange}
                        />
                    </td>
                    <td>None</td>
                </tr>
            </tbody>
        </Table>
    }

    function toggleNewAddressHidden() {
        addressDivHidden.set(!addressDivHidden.get());
        newAddress.set({
            clientId: client.get().id,
            street: '',
            street2: '',
            city: '',
            state: '',
            zip: ''
        });
    }

    function newAddressForm() {
        return <Form>
            <h6>Add Address</h6>
            <div className={'clientAddress'}>
                <div id='address block'>
                    <Form.Control id={`street`}
                                  onChange={e => newAddress.street.set(e.target.value)}
                                  value={newAddress.get().street}
                                  placeholder={'Street'}
                    />
                    <Form.Control id={`street2`}
                                  onChange={e => newAddress.street2.set(e.target.value)}
                                  value={newAddress.get().street2}
                                  placeholder={'Street 2'}
                    />
                    <InputGroup>
                        <Form.Control id={`city`}
                                      onChange={e => newAddress.city.set(e.target.value)}
                                      value={newAddress.get().city}
                                      placeholder={'City'}
                        />
                        <Form.Control onChange={e => newAddress.state.set(e.target.value)}
                                      id={`state`}
                                      value={newAddress.get().state}
                                      placeholder={'State'}
                        />
                        <Form.Control onChange={e => newAddress.zip.set(e.target.value)}
                                      id={`zip`}
                                      value={newAddress.get().zip}
                                      placeholder={'Zip'}
                        />
                    </InputGroup>
                </div>
            </div>
        </Form>
    }

    function addNewAddressDiv() {
        return <div id={'newAddress'}>
            <div id={`newAddressDiv_${addressDivHidden.get()}`}>
                {newAddressForm()}
                <div className={'buttons'}>
                    <Button onClick={toggleNewAddressHidden}>Cancel</Button>
                    <Button onClick={handleNewAddressSave}>Save</Button>
                </div>
            </div>

            <Button id={`newAddressDiv_${!addressDivHidden.get()}`} variant={"secondary"}
                    onClick={toggleNewAddressHidden}>Add New Address</Button>
        </div>
    }

    function handleNewAddressSave() {
        createAddress(newAddress.get(), () => {
            setTimeout(_ => {
                getClientAddresses(client.get().id, addresses => {
                    client.addresses.set(addresses);
                })
                toggleNewAddressHidden();
            }, 50);
        });
    }

    return (
        <div id={'addressBlock'}>
            <h5>Addresses: </h5>
            {addresses.length !== 0 &&
                displayAddresses()
            }
            {addresses.length < 1 &&
                <p>No Addresses found.</p>
            }
            {addNewAddressDiv()}
        </div>
    )
}

export default AddressBlock;